module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Cake-176fceb07b1ac56612eac59176b6bdab.svg";